import { render, staticRenderFns } from "./AddNameModal.vue?vue&type=template&id=db4e05c0"
import script from "./AddNameModal.vue?vue&type=script&lang=js"
export * from "./AddNameModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports